import { Skeleton } from "@/components/ui/adapters";
import React, { type FC } from "react";
import MessageHistorySkeleton from "./MessageHistory";

const MessagesPanelHeader: FC = () => {
  return (
    <div
      data-testid="room-skeleton-header"
      className="relative flex h-16 w-full min-w-0 shrink-0 items-center justify-between bg-background-light px-3 py-2 shadow-header xl:h-[72px] xl:rounded-t-xl xl:p-4"
    >
      <div className="flex min-w-0 flex-row gap-2 items-center">
        <div className="size-10 shrink-0 xl:hidden" />
        <Skeleton className="flex rounded-full size-8" />
        <div className="flex flex-col gap-1">
          <Skeleton className="flex rounded-xl h-4 w-[100px]" />
          <Skeleton className="flex rounded-xl h-3 w-[150px]" />
        </div>
      </div>
      <div className="h-10 w-10 flex justify-center items-center">
        <Skeleton className="flex rounded-full size-6" />
      </div>
    </div>
  );
};

const MessagesPanelFooter: FC = () => {
  return (
    <div
      data-testid="room-skeleton-footer"
      className="flex flex-row gap-4 items-center p-4 w-full h-[72px] shrink-0"
    >
      <div className="flex flex-row gap-2 items-center">
        <Skeleton className="flex rounded-md size-8 shrink-0" />
        <Skeleton className="size-6 shrink-0 rounded-md" />
      </div>
      <div className="h-10 min-w-0 flex-1 border border-muted-light rounded-md flex justify-start items-center bg-white px-2">
        <p className="app-text-body1 text-muted-light">Aa</p>
      </div>
      <Skeleton className="h-6 w-6 rounded-full" />
    </div>
  );
};

const RoomDetailSkeleton: FC = () => {
  return (
    <div className="size-full min-h-0 min-w-0 overflow-hidden flex flex-col rounded-none xl:rounded-xl bg-white [&_.animate-pulse]:animate-none">
      <MessagesPanelHeader />
      <div
        data-testid="room-skeleton-content"
        aria-busy
        className="relative w-full min-h-0 flex-1 overflow-hidden"
      >
        <MessageHistorySkeleton />
      </div>
      <MessagesPanelFooter />
    </div>
  );
};

export { RoomDetailSkeleton };
